import { useTranslation } from 'react-i18next'
import RehaboScene from './RehaboScene'

/** Moduly Rehaba v poradí, v akom ich klinika pri práci používa. */
const FEATURES = [
  'rehabo_f_calendar',
  'rehabo_f_clients',
  'rehabo_f_portal',
  'rehabo_f_insurance',
  'rehabo_f_sales',
  'rehabo_f_exercises',
  'rehabo_f_campaigns',
  'rehabo_f_stock',
] as const

export default function Projects() {
  const { t } = useTranslation()
  return (
    <section id="projects" className="relative py-24 px-6">
      {/* Section glow */}
      <div aria-hidden className="pointer-events-none absolute inset-x-0 bottom-0 -z-10">
        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] rounded-full bg-violet-600/6 blur-[100px]" />
      </div>

      <div className="max-w-6xl mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-xs uppercase tracking-widest text-indigo-400 font-medium">{t('projects.headline')}</span>
          <h2 className="text-4xl md:text-5xl mt-3 mb-4">{t('projects.headline')}</h2>
          <p className="text-slate-200/80">{t('projects.subheadline')}</p>
        </div>

        {/* Rehabo project card */}
        <div className="isolate rounded-2xl border border-indigo-300/25 bg-[linear-gradient(145deg,#2b4076_0%,#1e2f5a_100%)]">
          <div className="grid lg:grid-cols-[minmax(0,1fr)_minmax(0,1.2fr)] gap-0">
            {/* Left: info */}
            <div className="p-8 md:p-10 flex flex-col justify-center gap-5">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-xl bg-indigo-200/15 border border-indigo-200/30 flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="w-5 h-5 text-indigo-400">
                    <path d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z" />
                  </svg>
                </div>
                <span className="text-xs text-indigo-400 font-medium uppercase tracking-wider">Rehabo</span>
              </div>

              <div>
                <h3 className="text-2xl md:text-[1.75rem] leading-tight font-bold text-white mb-3">
                  {t('projects.rehabo_title')}
                </h3>
                <p className="text-slate-100/80 leading-relaxed">
                  {t('projects.rehabo_desc')}
                </p>
              </div>

              {/* Moduly systému - hlavný obsah karty, nie tech stack */}
              <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-2.5">
                {FEATURES.map(key => (
                  <li key={key} className="flex gap-2.5 text-sm text-slate-100/75 leading-snug">
                    <svg
                      aria-hidden
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      className="w-4 h-4 mt-0.5 shrink-0 text-indigo-400"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.7 5.3a1 1 0 0 1 0 1.4l-7.5 7.5a1 1 0 0 1-1.4 0L3.3 9.7a1 1 0 1 1 1.4-1.4l3.8 3.8 6.8-6.8a1 1 0 0 1 1.4 0Z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <span>{t(`projects.${key}`)}</span>
                  </li>
                ))}
              </ul>

              <div className="flex flex-wrap gap-2">
                {['rehabo_tag1', 'rehabo_tag2', 'rehabo_tag3'].map(tag => (
                  <span key={tag} className="text-xs px-3 py-1.5 rounded-full bg-white/12 border border-white/15 text-slate-100/80">
                    {t(`projects.${tag}`)}
                  </span>
                ))}
              </div>

              {/* Technológie heslovite, názvy sa neprekladajú */}
              <p className="font-mono text-xs text-slate-300/80">Spring Boot · React · PostgreSQL · Docker</p>
            </div>

            {/* Right: animovaná ukážka Rehaba */}
            <div className="relative p-6 md:p-10 border-t lg:border-t-0 lg:border-l border-white/5 flex items-center justify-center">
              <RehaboScene />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
